import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import en from "dayjs/locale/en";

dayjs.locale({
  ...en,
  weekStart: 1
});
dayjs.extend(utc);
dayjs.extend(timezone);

export const getLocaleFormattedDate = (date: string, orgTimezone?: string) => {
  if (!date) return "";
  try {
    return new Date(date).toLocaleString([], {
      timeZone: orgTimezone,
      year: "numeric",
      month: "long",
      day: "numeric"
    });
  } catch (error) {
    return new Date(date).toLocaleString([], {
      year: "numeric",
      month: "long",
      day: "numeric"
    });
  }
};

const dateToOrgTimezone = (date: string | Date, orgTimezone?: string) => {
  if (!orgTimezone) return dayjs(date);
  try {
    return dayjs(date).tz(orgTimezone);
  } catch (error) {
    return dayjs(date);
  }
};

export const getUTCWeekStartEndDates = (dateString: string, orgTimezone?: string) => {
  const tzDate = dateToOrgTimezone(dateString || new Date(), orgTimezone);
  const startDate = tzDate.startOf("week"); // Monday
  const endDate = tzDate.endOf("week"); // Sunday

  return {
    graphQLStartDate: startDate.toISOString().slice(0, 16),
    graphQLEndDate: endDate.toISOString().slice(0, 16),
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString()
  };
};

export const getCurrentDateISOString = () => new Date().toISOString();

export const milliSecondsToMinutes = (milliseconds: number, defaultToOne = true) => {
  if (!milliseconds) return 0;
  const value = Math.round(milliseconds / 60000);
  if (!value && defaultToOne) return 1;
  return value;
};

export const milliSecondsToHoursAndMinutes = (milliseconds: number) => {
  const hours = Math.floor(milliseconds / 3600000);
  const minutes = milliSecondsToMinutes(milliseconds % 3600000, !hours);
  return { hours, minutes };
};

export const getFormattedSubject = (subject: string) => {
  if (subject === "Reading") {
    return "Language Arts";
  }

  if (subject === "SEL") {
    return "Social and Emotional Learning";
  }

  return subject;
};

export function formatAssessmentDueDate(dueDate: string, userTimeZone: string | undefined) {
  const date = new Date(dueDate);
  const defaultTimeZone = "America/Los_Angeles"; // if no user time zone, default to Pacific Time
  const dateOnlyTimeZone = "UTC";

  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric"
  };
  const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(dueDate);

  if (isDateOnly) {
    options.timeZone = dateOnlyTimeZone; // prevents time shifting to previous day for date-only strings
  } else {
    options.timeZone = userTimeZone ?? defaultTimeZone;
  }

  const formattedDate = date.toLocaleDateString(undefined, options);
  return formattedDate;
}
